import React, {PropTypes} from 'react';
import Panel from 'shared/Panel.jsx';
import CaptainPaymentListContainer from './CaptainPaymentListContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const CaptainBalanceDetail = ({
  balance,
  selectedBalance, 
  selectedEntriesWithoutBalance,
  onPayBalanceClick,
  onPayBalanceOtherClick,
  onPaymentLogClick,
  enabledWebHooks,
  onWebHooksClick,
  environment,
  validationMessages
}) => (
  <div>
    <div className="row">
      <div className="col-xs-12">
        <div className="alert alert-info text-center">
          {`Payments may only be accepted for a single tournament per transaction.`}
        </div>
      </div>
    </div>

    <DisplayIf condition={Array.isArray(validationMessages) && validationMessages.length > 0}>
      <div className="row">
        <div className="col-xs-12">
          <div className="alert alert-danger text-center">
            <div>
              {validationMessages ? validationMessages.map((message, index) => (
                <div key={index}>
                  {`${message}`}
                </div>
              )) : null}
            </div>
          </div>
        </div>
      </div>
    </DisplayIf>

    <Panel className="panel-primary">
      <div className="row vertical-center">
        <div className="col-md-6">
          <h3 className="panel-title"
            style={{display: 'inline-block', marginBottom: 10, marginTop: 6}}>
            {`Captain's Balance: `} 
            <span>{`$${balance.formatCurrency(2)}`}</span>
            {' '}
            <small>{selectedBalance ? `(Amount to Pay - $${selectedBalance.formatCurrency(2)})` : ''}</small>
          </h3>
        </div>
        <div className="col-md-6 flex vertical-center right">
          <button
            style={{fontSize: 18, minWidth: 150, marginLeft: 10}}
            className="btn btn-link"
            type="button"
            onClick={onPaymentLogClick}>
            {'Payment Log'}
          </button>
          <button
            style={{minWidth: 150, marginLeft: 10}}
            type="button"
            className="btn btn-default btn-lg"
            disabled={!selectedBalance || selectedEntriesWithoutBalance}
            onClick={onPayBalanceOtherClick}>
            {'Cash/Check'}
          </button>
          <button
            style={{minWidth: 150, marginLeft: 10}}
            type="button"
            className="btn btn-primary btn-lg"
            disabled={!selectedBalance || selectedEntriesWithoutBalance}
            onClick={onPayBalanceClick}>
            {'Credit Card'}
          </button>
        </div>
        <DisplayIf condition={!!selectedBalance && (environment != 'PROD' && environment != 'PRODUCTION')} 
          className="custom-checkbox-container" 
          style={{ float: "right", paddingRight: 15 }}>
          <input type="checkbox"
            id="webHooks"
            checked={enabledWebHooks}
            onChange={event => onWebHooksClick(event.target.checked)}/>
          <label htmlFor="webHooks">
            Click here to process payments in real time.
          </label>
        </DisplayIf> 
        <DisplayIf condition={selectedEntriesWithoutBalance && selectedBalance > 0}> 
          <div className="col-xs-12">
            <div style={{marginTop: 18, marginRight: 6, marginBottom: -12, marginLeft: 6}}>
              <div className="alert alert-warning text-center">
                {`Cannot make payments to entries without balance.`}
              </div> 
            </div>
          </div>
        </DisplayIf>
      </div>
      <CaptainPaymentListContainer />
    </Panel>
  </div>
);

CaptainBalanceDetail.propTypes = {
  balance: PropTypes.number,
  selectedBalance: PropTypes.number,
  selectedEntriesWithoutBalance: PropTypes.bool,
  onPayBalanceClick: PropTypes.func,
  onPayBalanceOtherClick: PropTypes.func,
  onPaymentLogClick: PropTypes.func,
  enabledWebHooks: PropTypes.bool,
  onWebHooksClick: PropTypes.func,
  environment: PropTypes.string,
  validationMessages: PropTypes.arrayOf(PropTypes.string)
};

export default CaptainBalanceDetail;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainBalanceDetail.jsx